import * as React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { BirthdayDatePicker } from "./birthday-date-picker";
import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { formatDateForStorage, parseDateFromStorage } from "./modern-birthday-calendar";

interface FormBirthdayDatePickerProps {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  disabledDates?: (date: Date) => boolean;
}

export function FormBirthdayDatePicker({
  name,
  label,
  placeholder = "Select date of birth",
  required = false,
  disabled = false,
  disabledDates,
}: FormBirthdayDatePickerProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem>
          {label && (
            <FormLabel>
              {label}
              {required && <span className="text-destructive ml-1">*</span>}
            </FormLabel>
          )}
          <FormControl>
            <BirthdayDatePicker
              value={field.value ? parseDateFromStorage(field.value) : undefined}
              onChange={(date) => {
                field.onChange(date ? formatDateForStorage(date) : "");
              }}
              placeholder={placeholder}
              disabled={disabled}
              disabledDates={disabledDates}
            />
          </FormControl>
          <FormMessage>{fieldState.error?.message}</FormMessage>
        </FormItem>
      )}
    />
  );
}